import {
  GridCellParams,
  GridFilterItem,
  GridFilterOperator,
  getGridSingleSelectOperators
} from '@mui/x-data-grid';

import { AutocompleteOption } from '../customFilters/FilterCreators';

const isAnyOfOperator = getGridSingleSelectOperators().find(
  (operator) => operator.value === 'isAnyOf'
);

if (!isAnyOfOperator) {
  throw new Error("Could not find the 'isAnyOf' operator from MUI DataGrid.");
}

const creatorAndGroupsOperator: GridFilterOperator[] = [
  {
    ...isAnyOfOperator,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) {
        return null;
      }

      return (params: GridCellParams<AutocompleteOption>) => {
        const { value } = params;
        if (!value || typeof value !== 'object' || !('id' in value)) {
          return false;
        }
        return filterItem.value.some(
          (selected: AutocompleteOption) => selected.id === value.id
        );
      };
    }
    // InputComponent: FilterCreators
  }
];

export default creatorAndGroupsOperator;
